<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="reservations"
            :items-per-page="500"
            hide-default-footer
            fixed-header
            :disable-pagination="true"
        >
            <template v-slot:item.checkoutData="{ item }">
                <div>{{ item.checkout_data.hotelName }}</div>
            </template>
            <template v-slot:item.checkin="{ item }">
                {{ fullDateFormat(item.checkin) }}
            </template>
            <template v-slot:item.checkout="{ item }">
                {{ fullDateFormat(item.checkout) }}
            </template>
            <template v-slot:item.guest="{ item }">
                {{ item.firstName }} {{ item.lastName }}
            </template>
            <template v-slot:item.totalPrice="{ item }">
                <div class="text-no-wrap">{{ getCurrencySymbol(item.currency) }} {{ item.priceWithTax }}</div>
                <div
                    v-if="item.excludedTaxesAndFees"
                    class="text-no-wrap text-caption"
                >
                    (+ {{ getCurrencySymbol(item.currency) }} {{ item.excludedTaxesAndFees }} {{ $t('Fees') }})
                </div>
            </template>
            <template v-slot:item.amountRefunded="{ item }">
                <span
                    v-if="item.amountRefunded"
                    class="text-no-wrap"
                >
                    {{ getCurrencySymbol(item.currency) }} {{ item.amountRefunded }}
                </span>
            </template>
            <template v-slot:item.created_at="{ item }">
                {{fullDateFormat(item.created_at, true)}}
            </template>
            <template v-slot:item.booking_reference="{ item }">
                {{ item.booking_reference }}
            </template>
            <template v-slot:item.status="{ item }">
                <v-chip :color="item.cancelled ? 'red white--text' : ''">
                    {{ $t(`AdFormStatus.${item.status}`) }}
                </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
                <div class="d-flex">
                    <v-btn
                        class="text-decoration-underline  text-capitalize cursor-pointer mr-2"
                        @click.stop="loadHotelReservationPreview(item.id)"
                    >
                        {{ $t('Details') }}
                    </v-btn>
                    <v-menu
                        v-if="showCancelReservationButton(item)"
                        bottom
                        left
                        offset-y
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                color="black"
                                icon
                            >
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-item @click.stop="$emit('cancel-reservation', item.id)">
                                <v-list-item-icon class="mr-2">
                                    <v-icon color="red">mdi-close</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title class="red--text">{{ $t('Cancel reservation') }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { fullDateFormat } from '@/components/calendar/config';
import { mapGetters } from 'vuex';
import CurrencyMixin from '@/lib/CurrencyMixin';
import moment from 'moment';

export default {
  mixins: [CurrencyMixin],
  props: {
    reservations: {
      required: true,
      type: Array,
    },
  },
  computed: {
    ...mapGetters(['user', 'isAdmin']),
    headers() {
      return [
        { text: 'Hotel', value: 'checkoutData' },
        { text: this.$t('Check-in'), value: 'checkin' },
        { text: this.$t('Check-out'), value: 'checkout' },
        { text: this.$t('Guest'), value: 'guest' },
        { text: this.$t('Booking date'), value: 'created_at' },
        { text: this.$t('Total'), value: 'totalPrice' },
        { text: this.$t('Refunded'), value: 'amountRefunded' },
        { text: this.$t('Booking reference'), value: 'booking_reference' },
        { text: 'Status', value: 'status' },
        { text: '', value: 'actions' },
      ];
    },
  },
  methods: {
    fullDateFormat,
    showCancelReservationButton(item) {
      return item.userId
        && (item.userId === this.user.id || this.isAdmin)
        && !item.cancelled
        && moment().isBefore(moment(item.checkin).startOf('day'));
    },
    loadHotelReservationPreview(id) {
      this.$store.dispatch('setHotelReservationPreview', id);
    },
  },
};

</script>
